export default "/images/vendor/flag-icon-css/flags/1x1/pt.svg?6a0212390ef38b81c19a1be315ec3d31";